import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from "@ngx-translate/core";
import { Claims } from 'src/app/_models/common/claims';
import { Router, ActivatedRoute } from "@angular/router";
import { IApiRequest, ApiRequest } from 'src/app/_models';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { OrgBasicFunctionSubscriptionService } from 'src/app/_services/billing-pricing/Org-BasicFunction-Subscription.service';
import { ICONS } from 'src/app/_helpers/icons.constants';
import { ModalComponent } from 'src/app/shared/design-system/modal/modal.component';
import { ModalConfig } from "src/app/shared/design-system/modal/modal.modal";
import { ButtonComponent } from 'src/app/shared/design-system/button/button.component';
import { PanelComponent } from 'src/app/shared/design-system/panel/panel.component';
import { ButtonConfig } from "src/app/shared/design-system/button/button.modal";
import { PanelConfig } from "src/app/shared/design-system/panel/panel.modal";
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'book-demo-panel',
  templateUrl: './book-demo-panel.component.html',
  standalone: true,
  imports: [TranslateModule,ModalComponent,ButtonComponent,PanelComponent]
})
export class BookDemoPanelComponent implements OnInit {
 @Output() closePanelEvent = new EventEmitter<boolean>();

  public readonly ICONS = ICONS;

  claims!: Claims;

   panelConfig: PanelConfig = {
     id: 'book-demo-panel',
     title: 'Request a Demo',
     size: 'md',
     position: 'right',
     hasOverlay: true,
     projectedContent: true,
     hideCloseIcon: false,
   };
 
   cancelButtonConfig: ButtonConfig = {
     id: 'sample-cancel-btn',
     label: 'Keep Exploring',
     color: 'primary-outline',
     size: 'lg',
     disabled: false,
     ariaLabel: 'Keep Exploring'
   };
 
   submitButtonConfig: ButtonConfig = {
     id: 'sample-submit-btn',
     label: 'Request a Demo',
     color: 'primary',
     size: 'lg',
     disabled: false,
     ariaLabel: 'Request a Demo'
   };

   continueExploringButtonConfig: ButtonConfig = {
     id: 'continue-exploring-btn',
     label: 'Continue Exploring Application',
     color: 'primary',
     size: 'lg',
     disabled: false,
     ariaLabel: 'Continue Exploring Application',
     block: true
   };

   alreadySentButtonConfig: ButtonConfig = {
     id: 'already-sent-continue-btn',
     label: 'Continue Exploring Application',
     color: 'primary',
     size: 'lg',
     disabled: false,
     ariaLabel: 'Continue Exploring Application',
     block: true
   };

   showSuccess: boolean = false;
   /** True when the organisation has already booked a demo — shows the "already sent" popup. */
   isDemoBooked: boolean = false;

   successModalConfig: ModalConfig = {
     id: 'demo-received-modal',
     visible: false,
     title: '',
     size: 'md',
     variant: 'default',
     hiddenCloseIcon: true,
   };

   alreadySentModalConfig: ModalConfig = {
     id: 'demo-already-sent-modal',
     visible: false,
     title: '',
     size: 'md',
     variant: 'default',
     hiddenCloseIcon: true,
   };

   readonly calendlyUrl: string = environment.calendlyUrl;
   safeCalendlyUrl!: SafeResourceUrl;

   calendlyModalConfig: ModalConfig = {
     id: 'demo-calendly-modal',
     visible: false,
     title: '',
     size: 'xl',
     variant: 'default',
     headerIconSrc: ICONS.CALENDAR,
     hiddenCloseIcon: true,
   };

   calendlyConfirmButtonConfig!: ButtonConfig;

  constructor(
    private claimsService: ClaimsService,
    private router: Router,
    private orgBasicFunctionSubscriptionService: OrgBasicFunctionSubscriptionService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  userDetails: any;
  firstName: string = '';
  lastName: string = '';

  ngOnInit(): void {
    this.fnInitTranslations();
    this.fnHideTidioChat();
    this.fnSetUserName();
    this.safeCalendlyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.calendlyUrl);
    // If a demo is already booked, show the "already sent" popup instead of the book-demo panel.
    this.isDemoBooked = this.claims?.IsDemoBooked;
    if (this.isDemoBooked) {
      this.alreadySentModalConfig = { ...this.alreadySentModalConfig, visible: true };
    }
  }

  fnHideTidioChat(){
    if (window.tidioChatApi) {
      window.tidioChatApi.hide();
    }
  }

  /** Populate the design-system config labels/titles from the translator (book_demo_*). */
  private fnInitTranslations(): void {
    const t = (key: string) => this.translate.instant(key);
    this.panelConfig = { ...this.panelConfig, title: t('book_demo_request_demo') };
    this.cancelButtonConfig = { ...this.cancelButtonConfig, label: t('book_demo_keep_exploring'), ariaLabel: t('book_demo_keep_exploring') };
    this.submitButtonConfig = { ...this.submitButtonConfig, label: t('book_demo_request_demo'), ariaLabel: t('book_demo_request_demo') };
    this.continueExploringButtonConfig = { ...this.continueExploringButtonConfig, label: t('book_demo_continue_exploring'), ariaLabel: t('book_demo_continue_exploring') };
    this.alreadySentButtonConfig = { ...this.alreadySentButtonConfig, label: t('book_demo_continue_exploring'), ariaLabel: t('book_demo_continue_exploring') };
    this.calendlyModalConfig = { ...this.calendlyModalConfig, title: t('pricing_label_booknow') };
    this.calendlyConfirmButtonConfig = {
      id: 'calendly-confirm-btn',
      label: t('book_demo_confirm'),
      color: 'primary',
      size: 'md',
      disabled: false,
      ariaLabel: t('book_demo_confirm')
    };
  }

  /** Resolve the logged-in user's name from the stored user details. */
  private fnSetUserName() {
    if (localStorage.getItem("currentUser")) {
      this.userDetails = JSON.parse(localStorage.getItem("currentUser"));
      if (this.userDetails.RequestInfo) {
        this.firstName = this.userDetails.RequestInfo.FirstName;
        this.lastName = this.userDetails.RequestInfo.LastName;
      } else if (this.userDetails.responseInfo) {
        this.firstName = this.userDetails.responseInfo.firstName;
        this.lastName = this.userDetails.responseInfo.lastName;
      }
    } else if (localStorage.getItem("registereduser")) {
      this.userDetails = JSON.parse(localStorage.getItem("registereduser"));
      if (this.userDetails) {
        this.firstName = this.userDetails.FirstName;
        this.lastName = this.userDetails.LastName;
      }
    }
  }

  fnClosePanel() {
        this.closePanelEvent.emit(true);
    }

  /** Open the Calendly booking popup from the Request a Demo button. */
  fnOpenCalendlyModal() {
    this.calendlyModalConfig = { ...this.calendlyModalConfig, visible: true };
  }

  fnCloseCalendlyModal() {
    this.calendlyModalConfig = { ...this.calendlyModalConfig, visible: false };
  }

  /** Dismissing the Calendly popup without confirming returns to the Book Demo panel. */
  onCalendlyModalVisibleChange(visible: boolean) {
    this.calendlyModalConfig = { ...this.calendlyModalConfig, visible };
  }

  /** Confirm from the Calendly popup: save the demo request via BookDemo, then show the "received" info panel. */
  fnConfirmDemoRequest() {
    this.orgBasicFunctionSubscriptionService.BookDemo().subscribe({
      next: () => {
        this.fnCloseCalendlyModal();
        this.showSuccess = true;
        this.successModalConfig = { ...this.successModalConfig, visible: true };
        // Keep claims in sync so re-opening in this session shows the "already sent" popup.
        if (this.claims) {
          this.claims.IsDemoBooked = true;
          this.claimsService.updateClaims(this.claims);
        }
      },
      error: () => {
        this.fnCloseCalendlyModal();
      },
    });
  }

  /** Dismissing the "received" info panel closes the whole Book Demo flow. */
  onSuccessModalVisibleChange(visible: boolean) {
    this.successModalConfig = { ...this.successModalConfig, visible };
    if (!visible) {
      this.fnClosePanel();
    }
  }

  /** Dismissing the "already sent" popup closes the whole Book Demo flow. */
  onAlreadySentModalVisibleChange(visible: boolean) {
    this.alreadySentModalConfig = { ...this.alreadySentModalConfig, visible };
    if (!visible) {
      this.fnClosePanel();
    }
  }

}
